import { immerOn } from 'ngrx-immer/store';
import { INITIAL_PRICE_RANGE } from './price.state';
import {
  resetPriceFilter,
  setPriceFilter,
  setPriceFilterBasedOnUrlValues,
} from './price.actions';
import { resetAllFilters } from '../filter.actions';
import {
  FilterState,
  PriceFilterState,
  PriceOption,
  PriceRange,
} from '@immosky/types';

export const initialPriceState: PriceFilterState = {
  isActive: false,
  options: [],
  filter: INITIAL_PRICE_RANGE,
  default: INITIAL_PRICE_RANGE,
};

export const priceReducers = [
  immerOn(setPriceFilter, (state: FilterState, { filter }) => {
    updatePriceFilter(state, filter);
  }),
  immerOn(resetPriceFilter, resetAllFilters, (state: FilterState) => {
    updatePriceFilter(state, state.price.default);
  }),
  immerOn(
    setPriceFilterBasedOnUrlValues,
    (state: FilterState, { values }) => {
      const options = state.price.options;
      const minOption = options.find(
        (o: PriceOption) => o.value === values.min
      );
      const maxOption = options.find(
        (o: PriceOption) => o.value === values.max
      );

      if (minOption) {
        state.price.filter.min = minOption;
      }

      if (maxOption) {
        state.price.filter.max = maxOption;
      }

      state.price.isActive = isPriceFilterActive(
        state.price.filter,
        state.price.default
      );
    }
  ),
];

export function updatePriceFilter(state: FilterState, filter: PriceRange) {
  state.price.filter = filter;
  state.price.isActive = isPriceFilterActive(
    state.price.filter,
    state.price.default
  );
}

export function isPriceFilterActive(
  filter: PriceRange,
  defaultFilter: PriceRange
): boolean {
  const isMinLivingSpaceDefault = filter.min.value === defaultFilter.min.value;
  const isMaxLivingSpaceDefault = filter.max.value === defaultFilter.max.value;
  return !(isMinLivingSpaceDefault && isMaxLivingSpaceDefault);
}
